
const hydrationProductSliderProgress = {
  init(section) {
    const sliderTrack = section.querySelector('[id^="Slider-"]');
    const progressFill = section.querySelector("[data-hps-progress-fill]");
    if (!sliderTrack || !progressFill) return;

    const updateProgress = () => {
      const scrollWidth = sliderTrack.scrollWidth;
      const clientWidth = sliderTrack.clientWidth;
      const maxScroll = scrollWidth - clientWidth;

      if (maxScroll <= 0) {
        progressFill.style.width = '100%';
        progressFill.style.transform = `translateX(0)`;
        return;
      }

      const scrollLeft = sliderTrack.scrollLeft;
      const widthPercent = Math.max((clientWidth / scrollWidth) * 100, 10);
      progressFill.style.width = `${widthPercent}%`;

      const scrollPercent = Math.min(Math.max(scrollLeft / maxScroll, 0), 1);
      const maxTranslateX = ((100 / widthPercent) * 100) - 100;
      const translateX = scrollPercent * maxTranslateX;

      progressFill.style.transform = `translateX(${translateX}%)`;

      const prevBtn = section.querySelector('.is-prev');
      const nextBtn = section.querySelector('.is-next');
      if (prevBtn) prevBtn.toggleAttribute('disabled', scrollPercent <= 0.01);
      if (nextBtn) nextBtn.toggleAttribute('disabled', scrollPercent >= 0.99);
    };

    // Initialize custom seamless horizontal scrolling matching Swiper behavior perfectly
    const prevBtn = section.querySelector('.is-prev');
    const nextBtn = section.querySelector('.is-next');

    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        sliderTrack.scrollBy({ left: -sliderTrack.clientWidth, behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        sliderTrack.scrollBy({ left: sliderTrack.clientWidth, behavior: 'smooth' });
      });
    }

    sliderTrack.addEventListener("scroll", updateProgress, { passive: true });
    window.addEventListener("resize", updateProgress);

    setTimeout(updateProgress, 100);
    
    const observer = new MutationObserver(updateProgress);
    observer.observe(sliderTrack, { childList: true, subtree: true });
  },

  initAll() {
    document.querySelectorAll("[data-hps-progress-section]").forEach((section) => this.init(section));
  }
};

document.addEventListener("DOMContentLoaded", () => hydrationProductSliderProgress.initAll());
document.addEventListener("shopify:section:load", () => hydrationProductSliderProgress.initAll());

